export default __webpack_public_path__ + "static/media/BackgroundStakeAzulComCarteiraLG.dc9b8a50.png";